import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

export const ModalButtons = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  marginTop: 25,

  '& button:first-child': {
    marginRight: 15,
  },
});
